export default function TS_Exercises() {
  return (
    <div>
      <h1>TS Exercises</h1>
      <p>This is the TS Exercises page.</p>
    </div>
  );
}